import { MARITAL_STATUS, OPTION_VALUES, PaymentOptionName } from "@ipru-common/constants/InputValues";
import { LMS_CONSTANTS } from "@ipru-common/constants/SiteConstants";
import { PRODUCT_CODES, PRODUCT_NAMES } from "@ipru-common/constants/products";
import GlobalStore from "@ipru-common/store/GlobalStore";
import { getReverseRelation, readQueryParams } from "../CommonFunctions";
import { getCurrentTimeStamp } from "../SavingsAppForm/SavingAppFormsUtils";

const getIwishNetCoreInput = () => {
  const { quoteFormData, calculatorFormData, existingCustomer, currentPageStep, appFormData } =
    GlobalStore.getSnapshot();
  const queryParams = readQueryParams();

  const urlParams = new URLSearchParams(window?.location?.search);
  const params = Object.fromEntries(urlParams?.entries());

  const getAppFormStep = () => {
    let result = 1;
    if (!appFormData?.appNO) {
      result = 1;
    } else {
      if (appFormData?.stepsCleared?.personalDetails && !appFormData?.stepsCleared?.nomineeDetails) {
        result = 2;
      } else if (appFormData?.stepsCleared?.nomineeDetails && !appFormData?.stepsCleared?.healthDetails) {
        result = 3;
      } else if (appFormData?.stepsCleared?.healthDetails) {
        result = 4;
      }
    }
    return result;
  };

  let ipsUserInputs = {
    vitalcare_SA: quoteFormData?.SA,
    surgicalcare_SA: quoteFormData?.SA,
    maternitycare_SA: quoteFormData?.SA,
    Pregnancy: appFormData?.formWizard?.healthDetails?.pregnant,
    Pregnancy_week: appFormData?.formWizard?.healthDetails?.pregnancyWeeks,
    Dependent:
      calculatorFormData?.lifeAssuredFor === OPTION_VALUES.IWISH_BUYING_FOR.SELF
        ? OPTION_VALUES.N_NO
        : OPTION_VALUES.Y_YES,
    "Life Assured": calculatorFormData?.lifeAssuredFor,
    "Proposer Gender":
      calculatorFormData?.lifeAssuredFor === OPTION_VALUES.IWISH_BUYING_FOR.SELF ? calculatorFormData?.gender : "",
    "Proposer MobileNo": appFormData?.formWizard?.proposerDetails?.mobile_number,
    "Proposer Emailid": appFormData?.formWizard?.proposerDetails?.email_id,
    "Proposer DOB": calculatorFormData?.proposer_dob,
    "Proposer Annual Income": calculatorFormData?.proposer_yr_income,
    "Proposer Occupation": calculatorFormData?.proposer_occupation,
    surgicalcare_term: "",
    Maternitycare_term: "",
    "Relation with LA": getReverseRelation(calculatorFormData?.gender, calculatorFormData?.lifeAssuredFor) || "",
    age: calculatorFormData?.age,
    dob: calculatorFormData?.user_dob,
    gender: calculatorFormData?.gender,
    usetobacco: calculatorFormData?.tobacco,
    staff: calculatorFormData?.staff === OPTION_VALUES.STAFF_N ? OPTION_VALUES.N_NO : OPTION_VALUES.Y_YES,
    term: quoteFormData?.term,
    premiumpaymentoption: PaymentOptionName[quoteFormData?.paymentOption],
    sumassured: quoteFormData?.SA,
    payoutoptions: LMS_CONSTANTS[quoteFormData?.payoutType],
    paymentfrequency: LMS_CONSTANTS[quoteFormData?.tenure],
    plan: `${quoteFormData?.planType?.charAt(0).toUpperCase()}${quoteFormData?.planType?.slice(1)}`,
    mobileno: calculatorFormData?.mobileno,
    emailid: calculatorFormData?.emailid,
    trai_flag: calculatorFormData?.trai_flag ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    pincode: appFormData?.formWizard?.occupationDetails?.pincode,
    ppt: quoteFormData?.ppt,
    premium: quoteFormData?.breakupDetail?.total,
    nominee: appFormData?.formWizard?.nomineeDetails,
    annual_income: calculatorFormData?.yr_income,
    occupation: calculatorFormData?.calc_occupation,
    education: calculatorFormData?.calc_education,
    mrt_sts: MARITAL_STATUS[appFormData?.formWizard?.personalDetails?.marital_status],
    uid: "",
    page_name: LMS_CONSTANTS.I_WISH_PAGE_NAME,
    whatsapp_optin: quoteFormData?.wth_option ? "Yes" : "No",
    trai_flag_sm: OPTION_VALUES.N_NO,
    productid: PRODUCT_CODES.iwish,
    city: calculatorFormData?.city,
    productname: PRODUCT_NAMES.iwish,
    existing_cust: calculatorFormData?.employeeId || existingCustomer ? "Yes" : "No",
    state: calculatorFormData?.state,
    nri: calculatorFormData?.nri,
    ind_flag_nri: "",
    internationalmobileno: "",
    travelinlast1year: appFormData?.formWizard?.personalDetails?.travelled_abroad,
    nrimoblieno: calculatorFormData?.mobileno,
    nriemail: "",
    timestamp: getCurrentTimeStamp(),
    livinginindia: calculatorFormData?.is_nri_in_india ? OPTION_VALUES.NRI_YES : OPTION_VALUES.NRI_NO,
    nriarrivingdate: calculatorFormData?.nri_india_arriving_date,
    qdata: queryParams?.get("qdata"),
    appno: appFormData?.appNO,
    diabetes: quoteFormData?.isDiabetic === 1 ? OPTION_VALUES.Y_YES : OPTION_VALUES.N_NO,
    step: currentPageStep != "appFormScreen" ? "step1" : `step${getAppFormStep()}`,
    isenglish: params?.lan === "hi" ? "FALSE" : "TRUE",
    currentpagestep: currentPageStep,
  };

  return ipsUserInputs;
};
export default getIwishNetCoreInput;
